import { z } from 'zod';

export const renameCropResponseSchema = z.object({
  newLocalPath: z.string(),
});

export type IRenameCropResponse = z.infer<typeof renameCropResponseSchema>;
